(function () {
  var config = window.RelifeWelcomeOffer || {};
  var text = config.text || {};
  var offers = [];
  if (config.welcomeEligible !== false) offers.push({title: text.welcome_title, hint: text.welcome_hint, label: text.welcome_label, href: config.href});
  if (config.country === 'US') offers.push({title: text.shipping_title, hint: text.shipping_hint, label: text.shipping_label, href: '/collections/all'});
  var href = config.href || '/discount/WELCOME10?redirect=/account/register';
  var storageKey = 'relifeOffersClosed';
  var brushSrc = 'https://cdn.shopify.com/s/files/1/0903/2476/2993/files/relife-welcome-brush-logo-v1.png?v=1788067677';

  function isClosed() {
    try {
      return window.localStorage.getItem(storageKey) === '1';
    } catch (error) {
      return false;
    }
  }

  function rememberClosed() {
    try {
      window.localStorage.setItem(storageKey, '1');
    } catch (error) {
      return;
    }
  }

  function makeSpan(className, text) {
    var span = document.createElement('span');
    span.className = className;
    if (text) span.textContent = text;
    return span;
  }

  function isVisible(element) {
    if (!element) return false;
    var rect = element.getBoundingClientRect();
    var style = window.getComputedStyle(element);
    return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  }

  function updateBottomOffset(shell) {
    var defaultBottom = window.matchMedia && window.matchMedia('(max-width: 749px)').matches ? 13 : 18;
    var bottomOffset = defaultBottom;
    var hasPreviewBar = Boolean(document.querySelector('#PBarNextFrameWrapper, #PBarNextFrame'));

    if (hasPreviewBar) {
      bottomOffset = Math.max(bottomOffset, 86);
    }

    var cookieBanner = document.querySelector('#shopify-pc__banner');
    if (isVisible(cookieBanner)) {
      var bannerRect = cookieBanner.getBoundingClientRect();
      var reachesBottom = window.innerHeight - bannerRect.bottom < 80;
      if (reachesBottom) {
        var bannerOffset = Math.ceil(window.innerHeight - bannerRect.top + defaultBottom);
        var maxComfortOffset = Math.max(92, Math.round(window.innerHeight * 0.62));
        bottomOffset = Math.max(bottomOffset, Math.min(bannerOffset, maxComfortOffset));
      }
    }

    var shellHeight = shell.getBoundingClientRect().height || 92;
    var maxVisibleOffset = Math.max(defaultBottom, window.innerHeight - shellHeight - 28);
    bottomOffset = Math.min(bottomOffset, maxVisibleOffset);
    shell.style.setProperty('--rw10-bottom-offset', bottomOffset + 'px');
  }

  function watchOverlayOffset(shell) {
    updateBottomOffset(shell);
    window.setTimeout(function () { updateBottomOffset(shell); }, 500);
    window.setTimeout(function () { updateBottomOffset(shell); }, 1500);
    window.addEventListener('resize', function () { updateBottomOffset(shell); }, { passive: true });

    if (!window.MutationObserver || !document.body) return;
    var observer = new MutationObserver(function () { updateBottomOffset(shell); });
    observer.observe(document.body, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'],
    });
    window.setTimeout(function () { observer.disconnect(); }, 15000);
  }

  function addBrushOffer() {
    if (!document.body || document.querySelector('[data-relife-welcome-brush]') || isClosed() || !offers.length) return;

    var shell = document.createElement('div');
    shell.className = 'rw10';
    shell.setAttribute('data-relife-welcome-brush', '');

    var link = document.createElement('a');
    link.href = href;
    link.className = 'rw10-link';
    link.setAttribute('aria-label', offers[0].label);

    var tool = makeSpan('rw10-tool');
    tool.setAttribute('aria-hidden', 'true');
    var brush = document.createElement('img');
    brush.className = 'rw10-brush-img';
    brush.src = brushSrc;
    brush.alt = '';
    brush.width = 1254;
    brush.height = 1254;
    brush.loading = 'lazy';
    tool.appendChild(brush);

    var copy = makeSpan('rw10-copy');
    copy.appendChild(makeSpan('rw10-paint'));
    copy.appendChild(makeSpan('rw10-writer'));
    var title = makeSpan('rw10-written');
    var hint = makeSpan('rw10-hint');
    copy.appendChild(title);
    copy.appendChild(hint);
    var index = 0;
    var paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var interval;
    function showOffer() {
      var offer = offers[index];
      title.textContent = offer.title;
      hint.textContent = offer.hint;
      link.href = offer.href;
      link.setAttribute('aria-label', offer.label);
    }
    showOffer();
    var pause = document.createElement('button');
    pause.type = 'button';
    pause.className = 'rw10-pause';
    function updatePause() {
      pause.textContent = paused ? '\u25b6' : '\u2161';
      pause.setAttribute('aria-label', paused ? text.resume : text.pause);
    }
    updatePause();
    pause.addEventListener('click', function () { paused = !paused; updatePause(); });
    if (offers.length > 1) {
      shell.appendChild(pause);
      interval = window.setInterval(function () {
        if (!shell.isConnected) { window.clearInterval(interval); return; }
        if (paused || document.hidden || shell.matches(':hover') || shell.contains(document.activeElement)) return;
        index = (index + 1) % offers.length;
        showOffer();
      }, 8000);
    }

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'rw10-close';
    close.setAttribute('aria-label', text.close);
    close.textContent = '\u00d7';
    close.addEventListener('click', function (event) {
      event.preventDefault();
      rememberClosed();
      window.clearInterval(interval);
      shell.classList.add('is-hiding');
      window.setTimeout(function () {
        shell.remove();
      }, 190);
    });

    link.appendChild(tool);
    link.appendChild(copy);
    shell.appendChild(link);
    shell.appendChild(close);
    document.body.appendChild(shell);
    watchOverlayOffset(shell);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addBrushOffer);
  } else {
    addBrushOffer();
  }
})();
